function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-125.000000, -554.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(125.000000, 554.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19,15 C19,15.552 18.551,16 18,16 L6,16 C5.449,16 5,15.552 5,15 L5,10 C5,9.449 5.449,9 6,9 L8.5,9 C8.632,9 8.76,8.947 8.854,8.854 L10.561,7.146 C10.654,7.053 10.781,7 10.914,7 L13.086,7 C13.219,7 13.346,7.053 13.439,7.146 L15.146,8.854 C15.24,8.947 15.368,9 15.5,9 L18,9 C18.551,9 19,9.449 19,10 L19,15 Z M12,0 C5.383,0 0,5.384 0,12 C0,18.617 5.383,24 12,24 C18.617,24 24,18.617 24,12 C24,5.384 18.617,0 12,0 L12,0 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,14 C10.897,14 10,13.104 10,12 C10,10.898 10.897,10 12,10 C13.103,10 14,10.898 14,12 C14,13.104 13.103,14 12,14 M12,9 C10.346,9 9,10.346 9,12 C9,13.654 10.346,15 12,15 C13.654,15 15,13.654 15,12 C15,10.346 13.654,9 12,9",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5,9.5 C17.224,9.5 17,9.724 17,10 C17,10.276 17.224,10.5 17.5,10.5 C17.776,10.5 18,10.276 18,10 C18,9.724 17.776,9.5 17.5,9.5",
  id: "Fill-5"
})))));

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.9129e02d.svg";
export { ForwardRef as ReactComponent };